import { IDENTITY_TYPE } from 'common/constants/Types';
import i18n from 'common/locales';

export const SSO_LOGIN_ERR_MSG = {
  get E0010041() {
    return i18n.t('未找到匹配的企业', { ns: 'idp' });
  },
  get E0010042() {
    return i18n.t('未有可用的认证源，请联系管理员配置', { ns: 'idp' });
  },
  get E0010048() {
    return i18n.t('检测到多个匹配用户，登录失败！有问题请联系企业管理员。', { ns: 'idp' });
  },
  get E0010019() {
    return i18n.t('未检测到匹配用户，登录失败！有问题请联系企业管理员。', { ns: 'idp' });
  },
  get E0010035() {
    return i18n.t('检测到匹配用户已被停用，登录失败！有问题请联系企业管理员。', {
      ns: 'idp',
    });
  },
  get E0010049() {
    return i18n.t('获取用户信息失败！有问题请联系企业管理员。', { ns: 'idp' });
  },
  get E0010053() {
    return i18n.t('人员创建失败！有问题请联系企业管理员。', { ns: 'idp' });
  },
  get E0010007() {
    return i18n.t('用户名或密码错误，登录失败。', { ns: 'idp' });
  },
  get E0010131() {
    return i18n.t(
      '该用户名匹配到多个用户，请使用 UserPrincipalName 或 sAMAccountName 作为用户名进行登录。',
      { ns: 'idp' },
    );
  },
  get E0010167() {
    return i18n.t('用户不存在，请联系管理员', { ns: 'idp' });
  },
  get E0010165() {
    return i18n.t('用户名或密码输入有误', { ns: 'idp' });
  },
  get E0010179() {
    return i18n.t('人员创建失败。邮箱与企业内成员重复，请联系管理员。', { ns: 'idp' });
  },
  get E0010020() {
    return i18n.t('人员创建失败。您的手机号与企业内成员重复，请联系管理员。', {
      ns: 'idp',
    });
  },
  get E0010162() {
    return i18n.t('人员创建失败。您的登录用户名与企业内成员重复，请联系管理员。', {
      ns: 'idp',
    });
  },
};

export const SET_PASSWORD_TIPS = {
  [IDENTITY_TYPE.PASSWORD]: {
    get PASSWORD_EXPIRED() {
      return i18n.t('您的登录密码已过期，请重置密码', { ns: 'idp' });
    },
    get POLICY_UPGRADE() {
      return i18n.t('管理员更新了密码策略，请重置密码', { ns: 'idp' });
    },
    get INITIATIVE_CHANGE() {
      return i18n.t('为保障账号安全，当前账号需重置密码后使用', { ns: 'idp' });
    },
    get default() {
      return i18n.t('为保障账号安全，当前账号需重置密码后使用', { ns: 'idp' });
    },
  },
};
